<template>
  <div>
    <a-select
      :disabled="disabled"
      :mode="'multiple'"
      :placeholder="placeholder"
      :value="value"
      :class="class"
      allow-clear
      option-filter-prop="title"
      show-search
      @change="onChange"
    >
      <a-select-option
        v-for="item in records"
        :key="item.id"
        :title="item.bizNo"
        :value="item.id"
      >
        {{ item.bizNo }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onMounted, watch } from "vue";
import { LogSelectService } from "./log.service";

/**
 * 合同选择器
 *
 * 使用方式:
 * <contract-select v-model:value="formRef.contractId"></contract-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "WorkLogSelect",
  props: {
    externalData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },

    projectId: {
      type: String,
      default: undefined,
    },
    distinguish: {
      type: String,
      default: undefined,
    },
    //
    paymentContract: {
      type: String,
      default: undefined,
    },

    contractStatus: {
      type: Array,
      default: () => [],
    },
    class: {
      type: String,
      default: "append-to-body",
    },
  },
  emits: ["update:value", "change", "changetype"],
  setup(props, { emit }) {
    const { data: records, run, loading } = LogSelectService.useSimplePageApi();

    const onChange = async (id, option) => {
    //@ts-ignore
      let current = records.value.find(o=>o.id==id)
      // console.log(current, ">>>>>>>>>>>>>>>>>>>>>>>________????????");
      emit("update:value", id);
      emit("change",current);
      emit("changetype", current);
    };

    const search = async () => {
 

      await run(props.projectId);
      //编辑合同时，回显使用
      // if (props.externalData.projectId) {
      //   // console.log(records.value, "====================", props.externalData);
      //   records.value.push({
      //     id: props.externalData.contractId,
      //     name: props.externalData.contractName,
      //     current: 0,
      //     size: 0,
      //     total: 0,
      //     records: [],
      //     contractPricingManner: props.externalData.contractPricingManner,
      //   });
      // }
    };

    watch(
      () => props.projectId,
      async () => {
        // console.log(props.projectId, "props.distinguish>>>>>>>");
        await search();
      },
      { immediate: true }
    );

    // 修改项目时, 重新获取项目下的合同
    watch(
      () => props.value,
      async (newValue) => {
        if (newValue) {
          await search();
        }
      },
      { immediate: true }
    );

    return {
      records,
      loading,
      onChange,
    };
  },
});
</script>
